import InstallerTypes from './InstallerTypes';

export default InstallerTypes;
